/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Detect_Illegal_608_LabelInputs */

const en_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detect Illegal Chararacters (608)`)
};

const fr_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecter les caracteres illegaux (608)`)
};

const de_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illegale Zeichen erkennen (608)`)
};

const it_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rileva caratteri illegali (608)`)
};

const ru_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выявление недопустимых символов (608)`)
};

const es_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar personajes ilegales (608)`)
};

const zh_cn2_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测非法字符 (608)`)
};

const ja_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正な文字を検出する (608)`)
};

const hi_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवैध वर्णों का पता लगाना (608)`)
};

const pt_pt2_style_guide_manager_detect_illegal_608_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_608_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar caracteres ilegais (608)`)
};

/**
* | output |
* | --- |
* | "Detect Illegal Chararacters (608)" |
*
* @param {Style_Guide_Manager_Detect_Illegal_608_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_detect_illegal_608_label = /** @type {((inputs?: Style_Guide_Manager_Detect_Illegal_608_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Detect_Illegal_608_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_detect_illegal_608_label(inputs)
	if (locale === "de") return de_style_guide_manager_detect_illegal_608_label(inputs)
	if (locale === "it") return it_style_guide_manager_detect_illegal_608_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_detect_illegal_608_label(inputs)
	if (locale === "es") return es_style_guide_manager_detect_illegal_608_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_detect_illegal_608_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_detect_illegal_608_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_detect_illegal_608_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_detect_illegal_608_label(inputs)
	return en_style_guide_manager_detect_illegal_608_label(inputs)
});